import { isNotNilOrEmpty } from "client/Misc/utils";
import { resolveNavigationOptions } from "./connectToRouter";
import { Navigation } from "./navigation";
import { createUrlRelativeToEnvironment } from "client_legacy/ndaw/navigator";

export function createBrowserNavigationUrl(navigation: Navigation | string): string {
	const {
		path,
		queryString,
		fragment
	} = resolveNavigationOptions(navigation);

	// The root route is "/" so react-router navigation works as expected (see normalizePath in routing.ts),
	// however for the environment root, we don't want a trailing slash (react-router also doesn't produce a
	// trailing /).
	const baseUrl: string = (path === "/" ? "" : path)
		+ (
			isNotNilOrEmpty(queryString)
				? `?${queryString}`
				: ""
		)
		+ (
			isNotNilOrEmpty(fragment)
				? `#${fragment}`
				: ""
		);

	return createUrlRelativeToEnvironment(baseUrl);
}